import axios from 'axios'
import { EXTERNAL_TRANSACTIONS_API, TRANSACTION_LOGS_API } from './consts'
import { ExternalTransactionListQuery, TransactionLogListQuery } from './query.types'
import {
  ExternalTransactionListResponse,
  ExternalTransactionResponse,
  TransactionLogListResponse,
} from './response.types'

export const getExternalTransactions = (params: ExternalTransactionListQuery) => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== '' && v !== undefined && v !== null)
  )
  return axios.get<ExternalTransactionListResponse>(EXTERNAL_TRANSACTIONS_API, {
    params: filteredParams,
  })
}

export const getExternalTransaction = (id: number) => {
  return axios.get<ExternalTransactionResponse>(`${EXTERNAL_TRANSACTIONS_API}/${id}`)
}

export const getTransactionLogs = (params: TransactionLogListQuery) => {
  return axios.get<TransactionLogListResponse>(TRANSACTION_LOGS_API, { params })
}
